import { useState, useEffect } from 'react';
import { getAuth } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { db } from '@/utils/firebaseConfig';

const CookieBanner = () => {
    const [visible, setVisible] = useState(true);
    const auth = getAuth();

    useEffect(() => {
        const isCookieBannerHidden = localStorage.getItem('cookieBannerHidden');
        if (isCookieBannerHidden) {
            setVisible(false);
        }
    }, []);

    const handleAccept = async () => {
        localStorage.setItem('cookieBannerHidden', 'true');
        setVisible(false);

        const user = auth.currentUser;
        if (user) {
            await setDoc(doc(db, 'users', user.uid), { showAds: true }, { merge: true });
        }
    };

    if (!visible) return null;

    return (
        <div className="fixed bottom-0 left-0 right-0 bg-white bg-opacity-50 backdrop-blur p-4 shadow-md text-center border-2">
            <p className="text-gray-800">
                Diese Website verwendet Cookies, um Ihnen das beste Erlebnis auf unserer Website zu bieten.
                <button
                    onClick={handleAccept}
                    className="ml-2 bg-blue-600 text-white py-1 px-3 rounded hover:bg-blue-700 transition duration-300"
                >
                    Verstanden
                </button>
            </p>
        </div>
    );
};

export default CookieBanner;
